import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, locationSuffix } from "../lib/api";
import { Button } from "../components/ui/button";
import { ExternalLink, ArrowUpRight } from "lucide-react";
import Logo from "../components/Logo";

export default function SharedJob() {
  const { shareId } = useParams();
  const [job, setJob] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get(`/share/${shareId}`);
        setJob(r.data);
      } catch { setErr(true); }
    })();
  }, [shareId]);

  if (err) return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="label-tiny">404</div>
        <h1 className="font-heading text-3xl font-black mt-3">Shared lead not found</h1>
        <Link to="/" className="label-tiny inline-block mt-4 hover:text-zinc-900">← Home</Link>
      </div>
    </div>
  );
  if (!job) return <div className="min-h-screen flex items-center justify-center"><span className="label-tiny">Loading…</span></div>;

  return (
    <div className="min-h-screen bg-white text-zinc-900" data-testid="shared-job-page">
      <header className="border-b border-zinc-200">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <Logo size={28} />
          </Link>
          <span className="label-tiny">Shared lead</span>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <div className="label-tiny">Shared by {job.shared_by}</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tight mt-3" data-testid="shared-title">{job.title}</h1>
        <div className="mt-3 text-zinc-600">{job.company}{locationSuffix(job)}</div>
        {job.salary && <div className="mt-1 font-mono-jb text-sm text-zinc-600">{job.salary}</div>}

        {job.url && (
          <a href={job.url} target="_blank" rel="noopener noreferrer" className="inline-block mt-6" data-testid="shared-apply-link">
            <Button className="rounded-none bg-zinc-900 hover:bg-zinc-800 text-white h-11 px-6">
              Apply now <ExternalLink size={14} className="ml-1.5" />
            </Button>
          </a>
        )}

        {job.description && (
          <section className="mt-10">
            <div className="label-tiny mb-3">Description</div>
            <p className="whitespace-pre-wrap leading-relaxed text-zinc-800">{job.description}</p>
          </section>
        )}

        <div className="mt-16 border-t border-zinc-200 pt-8 flex items-center justify-between">
          <span className="text-sm text-zinc-600">Want to track your own job hunt?</span>
          <Link to="/" data-testid="shared-cta">
            <Button variant="outline" className="rounded-none border-zinc-300 h-10">
              Try ReInVocation <ArrowUpRight size={14} className="ml-1.5" />
            </Button>
          </Link>
        </div>
      </main>
    </div>
  );
}
